import { Skeleton } from '@/shared/components';
import { EXCHANGE_DISPLAYED_QUICK_SELECT_ITEMS_LIMIT } from '@/shared/config';

const ExchangeQuickSelectSkeleton = () => (
  <div className="flex items-center gap-[0.8rem]">
    {Array.from({ length: EXCHANGE_DISPLAYED_QUICK_SELECT_ITEMS_LIMIT }).map(
      (_, index) => (
        <Skeleton
          key={index}
          className="h-[2.4rem] w-[6.4rem] rounded-[0.8rem] bg-stroke"
        />
      )
    )}
  </div>
);

export { ExchangeQuickSelectSkeleton };
